import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=bf1681ae&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
import style0 from "./Profile.vue?vue&type=style&index=0&id=bf1681ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1681ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1681ae')) {
      api.createRecord('bf1681ae', component.options)
    } else {
      api.reload('bf1681ae', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=bf1681ae&scoped=true", function () {
      api.rerender('bf1681ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile.vue"
export default component.exports